import { ICommunicationsResponse, ICommunicationsRequestParams } from 'shared';

import { CacheTags } from '../../types/cacheTags';
import { emptySplitApi } from '../baseApi';
import { orgHeader } from '../../../../common/lib/axiosBaseQuery';

export const communicationsApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchCommunications: builder.query<ICommunicationsResponse, ICommunicationsRequestParams & { organisationId: string }>({
      query: ({ organisationId, ...params }) => ({
        url: `communications`,
        method: `GET`,
        headers: {
          [orgHeader]: organisationId,
        },
        params: {
          ...params,
        },
      }),
      providesTags: [
        { type: CacheTags.Communications, id: `LIST` },
      ],
    }),
    sendSmsOnDemand: builder.mutation<{ ok: boolean; actionId: string }, { organisationId: string; contactId: number; body: string; toNumber?: string; invoiceId?: string }>({
      query: ({ organisationId, contactId, ...payload }) => ({
        url: `communications/contact/${contactId}/on-demand-sms`,
        method: `POST`,
        headers: {
          [orgHeader]: organisationId,
        },
        data: payload,
      }),
      invalidatesTags: [
        { type: CacheTags.Communications, id: `LIST` },
      ],
    }),
    sendEmailOnDemand: builder.mutation<{ ok: boolean; actionId: string }, { organisationId: string; contactId: number; body: string; subject: string; toEmail?: string; invoiceId?: string; replyToInboundEmailId?: string }>({
      query: ({ organisationId, contactId, ...payload }) => ({
        url: `communications/contact/${contactId}/on-demand-email`,
        method: `POST`,
        headers: {
          [orgHeader]: organisationId,
        },
        data: payload,
      }),
      invalidatesTags: [
        { type: CacheTags.Communications, id: `LIST` },
      ],
    }),
  }),
});

export const {
  useFetchCommunicationsQuery,
  useSendSmsOnDemandMutation,
  useSendEmailOnDemandMutation,
} = communicationsApi;
